var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('confirmation-modal',{attrs:{"text":_vm.confirmationModalText,"progress":_vm.loading},on:{"clickFalse":function($event){_vm.show = false},"clickTrue":_vm.action},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }